import { render, staticRenderFns } from "./supportForm.component.vue?vue&type=template&id=626a0034&scoped=true&"
import script from "./supportForm.component.vue?vue&type=script&lang=js&"
export * from "./supportForm.component.vue?vue&type=script&lang=js&"
import style0 from "./supportForm.component.vue?vue&type=style&index=0&id=626a0034&lang=scss&scoped=true&"
import style1 from "./supportForm.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a0034",
  null
  
)

export default component.exports